import { Timestamp } from "firebase/firestore";

export type MessageSchema = {
    SenderId: string,
    ReceiverId: string,
    Message: string,
    TimeStamp: Timestamp,
    IsRead: boolean,
};

const nameofMessageSchemaSenderId = "SenderId";
const nameofMessageSchemaReceiverId = "ReceiverId";
const nameofMessageSchemaMessage = "Message";
const nameofMessageSchemaTimeStamp = "TimeStamp";
const nameofMessageSchemaIsRead = "IsRead";
const nameofMessageSchemaCollection = "Message";

export {
    nameofMessageSchemaSenderId,
    nameofMessageSchemaReceiverId,
    nameofMessageSchemaMessage,
    nameofMessageSchemaTimeStamp,
    nameofMessageSchemaIsRead,
    nameofMessageSchemaCollection,
};

export type MessageView = MessageSchema & {
    Id: string,
};